import type { ComponentProps } from 'react';
import React from 'react';
import { View } from 'react-native';

import { useIsLoggedIn } from '@order/AuthMachine';
import { useFeatureFlag } from '@order/LaunchDarkly';

import { GreetingText } from './GreetingText';
import { HeroHeadlineText } from './HeroHeadlineText';

export const HomeScreenGreetings = React.memo(
  (props: HomeScreenGreetingsProps) => {
    const { greeting, heroHeadline, style, ...rest } = props;

    const isLoggedIn = useIsLoggedIn();
    const shouldUseOptimizedHeadline = useFeatureFlag(
      'CELS-952-short-homescreen-optimizations-enabled',
    );
    const shouldShowHeadlineText = !isLoggedIn || !shouldUseOptimizedHeadline;

    return (
      <View style={style} {...rest}>
        <GreetingText testID="homepage.welcome-text">{greeting}</GreetingText>

        {shouldShowHeadlineText ? (
          <HeroHeadlineText>{heroHeadline}</HeroHeadlineText>
        ) : null}
      </View>
    );
  },
);

// ─── Types ────────────────────────────────────────────────────────

type HomeScreenGreetingsProps = {
  readonly greeting: string;
  readonly heroHeadline: string;
} & ComponentProps<typeof View>;
